// extracted by mini-css-extract-plugin
export default {"charity-signup-form":"styles__charity-signup-form___acIZ8"};